export const USER_REFRESH_ACCESS_TOKEN_ERROR = "UserRefreshAccessTokenError";
export const ADVISOR_REFRESH_ACCESS_TOKEN_ERROR = "AdvisorRefreshAccessTokenError";
export const GENERAL_REFRESH_ACCESS_TOKEN_ERROR = "RefreshAccessTokenError";
